<template>
  <div class="modal-overlay">
    <div
      v-if="loading"
      class="mmodal-content"
      style="max-width: 97vw; position: relative; padding: 1em"
    >
      <button
        style="
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: red;
          color: white;
          border: none;
          padding: 5px 10px;
          cursor: pointer;
        "
        type="button"
        @click="closepModal"
      >
        <span style="font-size: 1.3em">X</span>
      </button>
      <h3 style="text-align: center">Loading...</h3>
    </div>

    <div v-if="!loading" class="mmodal-content" style="max-width: 97vw">
      <div class="modal-header mb-0">
        <table
          style="border: 1px solid #bbb; border-bottom: 2px solid black"
          class="table align-items-center mb-0"
        >
          <thead>
            <tr>
              <th scope="col" colspan="5">
                <h5 class="modal-title">Prescription Details</h5>
              </th>
              <th scope="col" style="display: flex; justify-content: flex-end">
                <button
                  style="background-color: red; color: white"
                  type="button"
                  @click="closepModal"
                >
                  <span style="font-size: 1.3em">X</span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr style="color: black">
              <td>
                Patient: <b>{{ patient_name }}</b>
              </td>
              <td>
                Age: <b>{{ getAge(dob) }}</b>
              </td>
              <td>
                Gender: <b>{{ gender }}</b>
              </td>
              <td>
                Email: <b>{{ email }}</b>
              </td>
              <td>
                Phone: <b>{{ phone }}</b>
              </td>
              <td>
                OPD: <b>{{ opd }}</b> || IPD: <b>{{ ipd }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-body">
        <div class="mt-2 card parent-div">
          <div class="table-container">
            <div v-if="prescriptions.length < 1">
              <span style="color: maroon; align-self: center"
                >No drugs found for this prescription.</span
              >
            </div>

            <table
              v-if="prescriptions.length > 0"
              class="table align-items-center mb-0"
            >
              <thead style="background-color: rgb(209, 209, 224)">
                <tr style="color: black">
                  <th>#SID</th>
                  <th>Medicine/Item</th>
                  <th>Dosage</th>
                  <th>Frequency</th>
                  <th>Quantity</th>
                  <th>SKU</th>
                  <th>Instructions</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="prescription in prescriptions"
                  :key="prescription.id"
                >
                  <th>{{ prescription.id }}</th>
                  <td style="color: black">
                    <ItemFormat
                      :ItemName="prescription.item_name"
                      :ItemBrand="prescription.brand_name"
                      :ItemStrength="prescription.item_strength"
                    />
                  </td>
                  <td>{{ prescription.dosage }}</td>
                  <td>{{ prescription.frequency }}</td>
                  <td>{{ prescription.quantity }}</td>
                  <td>{{ prescription.batch_no || "N/A" }}</td>
                  <td>{{ prescription.instructions }}</td>
                  <td
                    :style="{
                      color: prescription.is_issued == '0' ? 'red' : 'green',
                    }"
                  >
                    {{ prescription.is_issued == "0" ? "Pending" : "Issued" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import ItemFormat from "../../Inventory/components/ItemName.vue";
import dob_to_age from "../../../timezone/dob_to_age.js";

export default {
  name: "ViewPrescriptionModal",
  data() {
    return {
      patient_name: "",
      dob: "",
      gender: "",
      opd: "",
      ipd: "",
      phone: "",
      email: "",
      prescriptions: [],
      loading: true,
    };
  },
  props: {
    pres_id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ItemFormat,
  },
  methods: {
    getAge(dob) {
      if (dob == null) {
        return "";
      } else {
        return dob_to_age(dob);
      }
    },
    async callApi() {
      // console.log("api is being called");
      this.loading = true;
      const url = "view_user_prescriptions_issued_and_unissued";
      const body = {
        pres_id: this.pres_id,
      };
      const res = await generalApiRequest(url, "POST", body, 1);
      console.log(res);

      this.patient_name = res.patient.name;
      // this.age = res.patient.
      // console.log(res.patient);

      this.dob = res.patient.dob;
      this.gender = res.patient.gender;
      this.opd = res.patient.opd;
      this.ipd = res.patient.ipd;
      this.phone = res.patient.phone;
      this.passport = res.patient.id_number;
      // this.residence = res.patient.
      this.email = res.patient.email;

      this.prescriptions = res.data;

      // get batches
      var detail_ids = [];
      res.data.forEach((element) => {
        detail_ids.push(element.id);
      });

      const sku_url = "view_prescription_skus";
      const sku_body = {
        pres_details_ids: detail_ids,
      };

      const sku_res = await generalApiRequest(sku_url, "POST", sku_body, 1);
      // console.log(sku_res);
      this.batches = sku_res.data;
      this.editValues = {};
      this.rowsOnEditMode = [];
      console.log(this.editValues);

      this.loading = false;
    },
    closepModal() {
      this.$emit("close-view-pres-modal");
    },
  },
  mounted() {
    this.callApi();
  },
};
</script>
